export default "__VITE_ASSET__BPlRZAYJ__"